import React from "react";
import { Row, Col, Card, Button, Badge } from "react-bootstrap";
import IMAGES from "../constants/images";
import { Icon } from "@iconify/react";

const pricingPlans = [
  {
    title: "Basic",
    seats: "For 3 Seats",
    price: "Free",
    per: "/monthly",
    features: [
      "Fast, Easy-to-use DNS",
      "Unmetered DDoS Protection",
      "Universal SSL Certificate",
      "Free Managed Ruleset",
    ],
    buttonText: "Try For Free",
    highlight: false,
    img: IMAGES.Circle_IMG1,
  },
  {
    title: "Pro",
    seats: "For 3 Seats",
    price: "$20",
    per: "/monthly",
    features: [
      "Fast, Easy-to-use DNS",
      "Unmetered DDoS Protection",
      "CDN",
      "Universal SSL Certificate",
    ],
    buttonText: "Try For Free",
    highlight: true,
    badge: "Popular",
    img: IMAGES.Circle_IMG2,
  },
  {
    title: "Business",
    seats: "For 4 Seats",
    price: "$200",
    per: "/monthly",
    features: [
      "Fast, Easy-to-use DNS",
      "Unmetered DDoS Protection",
      "CDN",
      "Universal SSL Certificate",
    ],
    buttonText: "Try For Free",
    highlight: false,
    img: IMAGES.Circle_IMG3,
  },
];

const ClientPricingCards = () => {
  return (
    <Row className="pricing_Box">
      {pricingPlans.map((plan, index) => (
        <Col key={index} xs={12} lg={4}>
          <Card
            className={`${
              plan.highlight ? "bg-primary text-white" : "bg-white"
            }`}
          >
            <Card.Body>
              <div className="pricing_header">
                <div
                  className="circle_img"
                  style={{
                    backgroundColor: plan.highlight ? "#ffffff" : "#CFE3F8",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={plan.img}
                    style={{
                      width: "35px",
                      height: "35px",
                      objectFit: "contain",
                      borderRadius: "0",
                    }}
                  />
                </div>
                <div className="flex-grow-1">
                  <h6
                    className={`mb-1 ${
                      plan.highlight ? "text-white" : "text-muted"
                    }`}
                  >
                    {plan.seats}
                  </h6>
                  <h4 className="fw-bold mb-0">{plan.title}</h4>
                </div>
                {plan.badge && <Badge text="primary">{plan.badge}</Badge>}
              </div>

              <p
                className={`pricingPara ${
                  plan.highlight ? "text-white" : "text-muted"
                }`}
              >
                For mission-critical applications that are core to your
                business.
              </p>

              <h2
                className={`fw-bold ${
                  plan.highlight ? "text-white" : "text-dark"
                }`}
              >
                {plan.price}{" "}
                <span
                  className={`fs-5 ${
                    plan.highlight ? "text-white" : "#6E6E73"
                  }`}
                >
                  {plan.per}
                </span>
              </h2>
              <h6 className="fw-bold mt-3">What's included</h6>
              <ul className="list-unstyled text-start">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="d-flex align-items-center">
                    <Icon
                      color={plan.highlight ? "#ffffff" : "#0071E3"}
                      icon="icon-park-solid:check-one"
                      fontSize={24}
                    />{" "}
                    <span className="ms-2">{feature}</span>
                  </li>
                ))}
              </ul>
              <Button
                variant={plan.highlight ? "light" : "info"}
                className="mt-3 w-100 rounded-pill"
              >
                {plan.buttonText}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ClientPricingCards;
